import { render, staticRenderFns } from "./ProductionList.vue?vue&type=template&id=f4ef1960&scoped=true"
import script from "./ProductionList.vue?vue&type=script&lang=js"
export * from "./ProductionList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4ef1960",
  null
  
)

export default component.exports